import { IUserAccess } from '@zeta-core';

const RiskOptions = [
  {
    label: 'Very High',
    value: 'VeryHighRisk',
    color: 'error',
  },
  {
    label: 'High',
    value: 'HighRisk',
    color: 'error',
  },
  {
    label: 'Moderate',
    value: 'ModerateRisk',
    color: 'warning',
  },
  {
    label: 'Low',
    value: 'LowRisk',
    color: 'success',
  },
  {
    label: 'Very Low',
    value: 'VeryLowRisk',
    color: 'success',
  },
  {
    label: 'No Risk',
    value: 'NoRisk',
    color: 'success',
  },
];

export default RiskOptions;

export const advisorMeetingType = [
  {
    label: 'Initial Meeting',
    value: 'Initial Meeting',
  },
  {
    label: 'Fact Find Meeting',
    value: 'Fact Find',
  },
  {
    label: 'Follow-up Meeting',
    value: 'Follow Up Meeting',
  },
  {
    label: 'Recommendation Meeting',
    value: 'Recommendation',
  },
  {
    label: 'Onboarding Meeting',
    value: 'Onboarding',
  },
];

export enum Currency {
  GBP = '£',
  USD = '$',
  EUR = '€',
  INR = '₹',
}

export enum Frequency {
  MONTHLY = 'Month',
  YEARLY = 'Year',
}

export enum Addon {
  ASK_ZETA = 'Ask Zeta',
  OPEN_BANKING = 'Open Banking',
  MPS = 'MPS',
}

export const formatCurrency = (amount: number, currencyCode: keyof typeof Currency): string => {
  return `${Currency[currencyCode]}${amount}`;
};

/**
 * Checks access type for features based on StatusCondition
 * @param features The features object from userAccess store
 * @param featureKey The key of the feature to check (e.g., 'Advisor-Client-FF')
 * @param statusCondition The specific status condition to check for (e.g., 'advise', 'recommendation')
 * @returns Object containing hasAccess (boolean) and isReadOnly (boolean) properties
 */
export const getClientFeatureAccess = (
  features: IUserAccess['access'] | undefined,
  featureKey: string,
  statusCondition: string,
  allowAll = false
): { hasAccess: boolean; isReadOnly: boolean } => {
  const featureConfig = features && features[featureKey];

  const normalizeStatusCondition = (value?: string) => {
    const normalized = (value || '')
      .toLowerCase()
      .replace(/[_\s-]+/g, '');

    if (normalized === 'paraplanning' || normalized === 'paraplanner') {
      return 'paraplanning';
    }

    return normalized;
  };

  // Default return value - no access
  const defaultResult = { hasAccess: false, isReadOnly: true };

  // If feature doesn't exist, return no access
  if (!featureConfig) {
    return defaultResult;
  }

  // Find a matching configuration with the provided StatusCondition
  const normalizedStatusCondition = normalizeStatusCondition(statusCondition);
  const matchingConfig = featureConfig.find((config: { StatusCondition: string; Type: string }) => {
    return normalizeStatusCondition(config.StatusCondition) === normalizedStatusCondition;
  });

  // If no matching config found, return no access
  if (!matchingConfig) {
    if (allowAll) {
      return {
        hasAccess: true,
        isReadOnly: false,
      };
    }
    return defaultResult;
  }

  // If matching config found, determine access type
  return {
    hasAccess: true,
    isReadOnly: matchingConfig.Type === 'Read',
  };
};
